<template>
  <div class="reviews">
    <div class="overflow-hidden">
      <ul v-touch:swipe.left="goRight" v-touch:swipe.right="goLeft" :style="sliderStyle" class="w-full p-0 flex flex-nowrap transition transform duration-500" v-if="content.items">
        <li @click="activate(i)" class="cursor-pointer flex-1 overflow-hidden" v-for="(item,  i) in content.items" :key="item._uid">
          <div class="review md:flex-row flex-col flex items-center justify-center gap-5">
            <img class="w-32 h-auto" :src="item.logo.filename" alt="logo client" />
            <p class="font-medium text-center px-1 text-base" v-html='`" ${item.text} "`'></p>
          </div>
        </li>
      </ul>
      <ul class="flex mx-auto gap-4 mt-8">
        <li
          @click="activate(i)"
          :class="i === activeItem ? 'bg-primary' : ''"
          class="cursor-pointer hover:bg-primary bg-transparent transition w-5 h-5 border-2 border-primary border-solid rounded-full"
          v-for="(item, i) in content.items"
          :key="item._uid"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeItem: 0,
    };
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  methods: {
    activate(i) {
      if (i !== this.activeItem) {
        this.activeItem = i;
      }
    },
    goRight() {
      this.content.items.length - 1 === this.activeItem
        ? (this.activeItem = 0)
        : this.activeItem++;
    },
    goLeft() {
      this.activeItem === 0
        ? (this.activeItem = this.content.items.length - 1)
        : this.activeItem--;
    },
  },
  computed: {
    sliderStyle() {
      let transformValue = -(
        (100 / this.content.items.length) *
        this.activeItem
      );

      let widthValue = this.content.items.length * 100;

      return {
        width: `${widthValue}%`,
        transform: `translateX(${transformValue}%)`,
      };
    },
  },
};
</script>

<style>
</style>